module.exports = __webpack_public_path__ + "static/media/frame-logo-mobile.be95b5f1.svg";